import { ContactUs, CopyrightFooter } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'
import { Button, Carousel, Col, Row } from 'react-bootstrap'

class AboutUs extends Container<{}, {}> {
  mapAppStateToContainerState(appState: IAppState): {} {
    return {}
  }

  render() {
    return (
      <section className="padding-top-lg">
        <div className="container" style={{ overflowX: 'hidden' }}>
          <div className="jumbotron animated fadeIn">
            <h1 className="hidden-xs">Leadership</h1>
            <h3 className="visible-xs">Leadership</h3>
            <p className="lead">FoundationMark tracks the investment performance of the private foundation universe and has created the most comprehensive performance benchmarks available. Investment returns have a direct, meaningful and measurable effect on a foundation's ability to support important causes. FoundationMark believes that providing independent, objective and transparent performance metrics can help foundations make better informed investment decisions.</p>
            <p className="lead">
              <strong className="text-primary">John Seitz</strong> is the founder of FoundationMark and serves at the CEO. Prior to his current position, John worked for an Outsourced Chief Investment Office (OCIO) managing assets for nonprofit organizations, before the OCIO firm, he spent 15 years in portfolio management and equity research. John graduated from Georgetown University with a BA in History, and earned an MBA from Northwestern University's Kellogg School of Management. In 1997 he received the Chartered Financial Analyst designation from AIMR.
            </p>
          </div>
        </div>

        <ContactUs />
        <CopyrightFooter />
      </section>
    )
  }
}

export {
  AboutUs
}



// WEBPACK FOOTER //
// ./src/app/containers/AboutUs/index.tsx